/** @format */

import { Box, Container, Divider, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { useApiFeedback } from "../app/useApiFeedback";
import { fetchAllConstantsThunk } from "../common/dropdowns/Api/constantSlice";
import MessageResponse from "../common/feedback/messageResponse";
import { sessions } from "../common/localstorage/SessionStorage";
import {
  loginApplicantThunk,
  selectApplicant,
} from "../features/applicant/ApplicantSlice";
import { ApplicationDetailsDto } from "../features/applicant/Models";
import AddressInfor from "../features/applicant/profile/components/AddressInfor";
import DocumentsInfo from "../features/applicant/profile/components/DocumentsInfo";
import GuardianInfo from "../features/applicant/profile/components/GuardianInfo";
import InstitutionInfo from "../features/applicant/profile/components/InstitutionInfo";
import Side from "../features/applicant/profile/components/Side";
import {
  fetchApplicationDatesThunk,
  selectHome,
} from "../features/home/homeSlice";
import { ApplicationSetDatesDto } from "../features/home/models";

function Applicant() {
  const dispatch = useAppDispatch();
  const applicantSelect = useAppSelector(selectApplicant) as any;
  const navigate = useNavigate();
  const [data, setData] = useState<ApplicationDetailsDto | null>(null);
  const homeSelect = useAppSelector(selectHome);
  const [dateData, setDateData] = useState<ApplicationSetDatesDto | null>(null);
  const [hasLoaded, setHasLoaded] = useState<boolean>(false);
  const { feedback, handleApiResponse } = useApiFeedback();

  useEffect(() => {
    dispatch(fetchApplicationDatesThunk()).then((resp: any) => {
      handleApiResponse(resp, false);
    });

    dispatch(fetchAllConstantsThunk());
  }, []);

  useEffect(() => {
    const resp = homeSelect.applicationDatesState.applicationDates;
    if (resp) {
      setDateData(resp);
    }
  }, [homeSelect.applicationDatesState.applicationDates]);

  useEffect(() => {
    if (!hasLoaded) {
      if (sessions.getToken()) {
        dispatch(loginApplicantThunk()).then((resp:any) => {
          handleApiResponse(resp, false);

          if (
            (resp.type.includes("fulfilled") &&
              resp.payload?.validation.code === 201) ||
            (resp.type.includes("fulfilled") &&
              resp.payload?.validation.code === 200)
          ) {
            const appData = resp.payload?.data?.application;
            if (
              appData.applicationStage === 0 ||
              appData.applicationStage === 1 ||
              appData.applicationStage === 2 ||
              appData.applicationStage === 3 ||
              appData.applicationStage === 4 ||
              appData.applicationStage === 5
            ) {
              navigate("/application");
            }
          }
        });

        setHasLoaded(true);
      }
    }
  }, []);

  useEffect(() => {
    if (
      applicantSelect.loginState.accessToken &&
      applicantSelect.loginState.accessToken
    ) {
      setData(applicantSelect.loginState.accessToken.application);
    }
  }, [applicantSelect.loginState.accessToken]);

  return (
    <Box
      sx={{
        bgcolor: (theme) =>
          theme.palette.mode === "light" ? "grey.50" : "background.default",
        minHeight: "100%",
        py: { xs: 2, md: 4 },
      }}
    >
      <Container maxWidth="lg" disableGutters sx={{ px: { xs: 2, sm: 3 } }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MessageResponse feedback={feedback} />
          </Grid>
          <Grid item xs={12}>
            <Side applicant={data} />
          </Grid>
          <Grid item xs={12}>
            <Divider sx={{ borderColor: "divider" }} />
          </Grid>
          <Grid item xs={12} md={4}>
            <AddressInfor applicant={data} />
          </Grid>
          <Grid item xs={12} md={8}>
            <InstitutionInfo applicant={data} />
          </Grid>
          <Grid item xs={12}>
            <DocumentsInfo applicant={data} />
          </Grid>
          <Grid item xs={12} sx={{ mb: { xs: 4, md: 6 } }}>
            <GuardianInfo applicant={data} />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Applicant;
